import axios from "axios";
import { supabase } from "./supabaseClient"; // Importar o cliente Supabase

// Obter API URL do sistema de configuração dinâmica
const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

console.log("REACT_APP_API_URL: " + (window.ENV?.REACT_APP_API_URL || process.env.REACT_APP_API_URL));
console.log("API_URL: " + API_URL);

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const stockService = {
  async createStockEntry(entryData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para criar entradas de stock."
        );
      }

      const response = await axiosInstance.post(`/stock/entry`, entryData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao criar entrada de stock"
        );
      }
      throw error;
    }
  },

  async getStockEntryById(id) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar detalhes da entrada de stock."
        );
      }

      const response = await axiosInstance.get(`/stock/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message ||
            "Erro ao buscar detalhes da entrada de stock"
        );
      }
      throw error;
    }
  },

  async getStockEntries(filters = {}) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar entradas de stock."
        );
      }

      const response = await axiosInstance.get(`/stock`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filters,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar entradas de stock"
        );
      }
      throw error;
    }
  },

  async getInactiveProducts() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar produtos desativados."
        );
      }

      const response = await axiosInstance.get(`/stock/inactive-products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar produtos desativados"
        );
      }
      throw error;
    }
  },

  async reactivateProduct(productId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para reativar produtos."
        );
      }

      const response = await axiosInstance.put(
        `/stock/inactive-products/${productId}/reactivate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao reativar produto"
        );
      }
      throw error;
    }
  },

  async deactivateProduct(productId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para desativar produtos."
        );
      }

      const response = await axiosInstance.put(
        `/stock/products/${productId}/deactivate`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao desativar produto"
        );
      }
      throw error;
    }
  },

  async updateStockEntry(id, entryData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para atualizar entradas de stock."
        );
      }

      const response = await axiosInstance.put(`/stock/${id}`, entryData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao atualizar entrada de stock"
        );
      }
      throw error;
    }
  },

  async processStockWithdrawal(withdrawalData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para processar baixa de stock."
        );
      }

      const response = await axiosInstance.post(
        `/stock/withdrawal`,
        withdrawalData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao processar baixa de stock"
        );
      }
      throw error;
    }
  },

  async getTotalStock() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar o stock total."
        );
      }

      // Assumindo que o backend terá um endpoint para o stock total
      const response = await axiosInstance.get(`/stock/total`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar stock total"
        );
      }
      throw error;
    }
  },

  async getCurrentStockByProductId(productId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar o stock do produto."
        );
      }

      // Assumindo que o backend terá um endpoint para o stock atual de um produto específico
      const response = await axiosInstance.get(
        `/stock/product/${productId}/current-quantity`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data; // Deve retornar { current_quantity: X }
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar stock do produto"
        );
      }
      throw error;
    }
  },

  async getStockMovementsByProductId(productId) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar movimentações de stock."
        );
      }

      const response = await axiosInstance.get(`/stock/movements`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { product_id: productId },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message ||
            "Erro ao buscar movimentações de stock por produto"
        );
      }
      throw error;
    }
  },

  async manualWithdrawal(withdrawalData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para registrar baixa manual."
        );
      }

      const response = await axiosInstance.post(
        `/stock/manual-withdrawal`,
        withdrawalData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao registrar baixa manual"
        );
      }
      throw error;
    }
  },

  async getManualWithdrawals(filters = {}) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar baixas manuais."
        );
      }

      const response = await axiosInstance.get(`/stock/manual-withdrawals`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: filters,
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar baixas manuais"
        );
      }
      throw error;
    }
  },

  async transferStock(transferData) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para transferir stock."
        );
      }

      const response = await axiosInstance.post(
        `/stock/transfer`,
        transferData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao transferir stock"
        );
      }
      throw error;
    }
  },

  async getLotsByProduct(productId, status) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar lotes do produto."
        );
      }

      const response = await axiosInstance.get(
        `/stock/lots-by-product/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          // Sem status, o backend devolve lotes disponíveis e em cura.
          params: status ? { status } : undefined,
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar lotes do produto"
        );
      }
      throw error;
    }
  },
};
